var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4998 9.72832V6.09957M9.4998 12.418V12.4499M14.0357 15.4721H4.96386C3.72469 15.4721 2.67894 14.6439 2.34993 13.5109C2.20948 13.0272 2.38205 12.5234 2.64601 12.0945L7.18195 3.82353C8.24468 2.09658 10.7549 2.09659 11.8177 3.82353L16.3536 12.0945C16.6176 12.5234 16.7901 13.0272 16.6497 13.5109C16.3207 14.6439 15.2749 15.4721 14.0357 15.4721Z",
    stroke: "#FF0000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErr);
export default __webpack_public_path__ + "static/media/err.2aa2a9d0fc161427849a4fd76eda8946.svg";
export { ForwardRef as ReactComponent };